let my_card = ( function( $ ) {

	let $cards;
	let elem_height;
	let elem_width;

	let _init = function() {
		$cards      = $( '.my-card' );
		elem_height = $cards.find( '.action-links' ).first().css( 'height' );
		elem_width  = $cards.find( '.action-links' ).first().css( 'width' );

		$cards.find( '.ticket-collapse .heading' ).on( 'click', _toggle_card_content );
		$cards.find( '.edit-actions a.toggle-actions' ).on( 'click', _toggle_card_actions );
		$cards.find( '.tooltip-toggle' ).on( 'click', _toggle_tooltip );

		if ( $cards.find( '.toggle-days' ).length > 0 ) {
			_setup_days_toggle();
		}
	};

	let _setup_days_toggle = function () {
		let $toggles = $cards.find( '.toggle-days' );

		$toggles.each( ( index, item ) => {
			let $toggle = $( item );

			$toggle.on( 'click', function( e ) {
				e.preventDefault();

				$( this ).toggleClass( 'open' );
				$( this ).closest( '.days' ).find( '.days-wrapper' ).slideToggle();
			} )

		});
	};

	let _toggle_tooltip = function( e ) {
		$( this ).closest( '.field-tooltip' ).toggleClass( 'open' );
		$( this ).next( '.tooltip-content' ).fadeToggle();

		e.preventDefault();
	};

	let _toggle_card_actions = function( e ) {
		let $action_links = $( this ).next( '.action-links' );
		let $parent = $( this ).parent();

		e.preventDefault();

		if ( ! $parent.hasClass( 'open' ) ) {
			_open_animation( $action_links );
			$parent.addClass( 'open' );
		} else {
			_close_animation( $action_links );
			$parent.removeClass( 'open' );
		}
	};

	let _open_animation = function( $elem ) {
		$elem.css( 'height', 0 );
		$elem.css( 'width', 0 );
		$elem.css( 'opacity', 0 );
		$elem.css( 'display', 'inline-block' );

		$elem.animate( {
			width: elem_width,
			height: elem_height,
			opacity: 1
		}, 500 );
	};

	let _close_animation = function( $elem ) {
		$elem.animate( {
			width: 0,
			height: 0,
			opacity: 0
		}, 400 );

		setTimeout( function() {
			$elem.css( 'display', 'none' );
		}, 400 );
	};

	let _toggle_card_content = function( e ) {
		let $target = $( this ).parent();

		e.preventDefault();

		if ( $target.hasClass( 'open' ) ) {
			_hide_content( $target.find( '.collapse-content' ) );

		} else {
			_hide_content( $cards.find( '.collapse-content' ) );

			_show_content( $( this ).next() );
		}
	};

	let _hide_content = function( $element ) {
		$element.slideUp();
		$element.parent().removeClass( 'open' );
	};

	let _show_content = function( $element ) {
		$element.slideDown();
		$element.parent().addClass( 'open' );
	};

	if ( $( '.my-card' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = my_card;